// extracted by mini-css-extract-plugin
export var anchor = "_51-0";
export var discard = "_51-4";
export var muiTooltipTooltip = "_51-6";
export var notificationBar = "_51-3";
export var saveButtonHoverSlotWrapper = "_51-5";
export var show = "_51-2";
export var spacer = "_51-1";